// The browser never requests agenda.crf.org directly. Faculty photos and the few static images
// Emma hosts load from /api/agenda-media/..., which fetches them from agenda.crf.org on
// the server (profile_photo answers with a redirect to the DigitalOcean Space, or the placeholder).

const AGENDA_ORIGIN = /^https?:\/\/agenda\.crf\.org\/(api\/v1\/faculty|img|media|storage)\//

export const AGENDA_MEDIA_PREFIX = "/api/agenda-media"

export function facultyPhotoUrl(facultyId) {
    return `${AGENDA_MEDIA_PREFIX}/api/v1/faculty/${facultyId}/profile_photo`
}

// Rewrite an agenda.crf.org image URL (e.g. a faculty image_url falling back to
// https://agenda.crf.org/img/person.png) to its same-origin path. Other URLs pass through.
export function agendaMediaUrl(url) {
    if (typeof url !== "string") return url
    return url.replace(AGENDA_ORIGIN, (match, dir) => `${AGENDA_MEDIA_PREFIX}/${dir}/`)
}
